import React, { useState } from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";

import RCSCampaignAnalyticsTab from "./RCSCampaignAnalyticsTab";
import RCSTemplateAnalyticsTable from "../RCSTemplateAnalytics/RCSTemplateAnalyticsTable";
import RCSTemplateAnalyticsTab from "../RCSTemplateAnalytics/RCSTemplateAnalyticsTab";

import BackButton from "../../common/back-button";
import CustomTabs from "../../common/custom-tabs";
import typography from "../../cssUtils/typography";
import { ColorsConstants } from "../../cssUtils/constants";

// RCS-only template analytics (list + detail drill-down). Mirrors the
// WhatsApp-only flow in TemplateAnalytics.js, scoped to RCS templates only.
const RCSTemplateAnalyticsReport = (props) => {
  const [showAnalytics, setShowAnalytics] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const handleTemplateClick = (template) => {
    setSelectedTemplate(template);
    setShowAnalytics(true);
  };

  const handleBackToTable = () => {
    setShowAnalytics(false);
    setSelectedTemplate(null);
  };

  return (
    <Box sx={{ mt: 3, mb: 1, mx: 3 }}>
      {!showAnalytics && (
        <>
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ ...typography.h1, mb: 0.5, fontWeight: 500, color: ColorsConstants.primaryBlue100 }}>
              Template Analytics
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Track delivery, read rates, and performance for your RCS templates.
            </Typography>
          </Box>

          <RCSTemplateAnalyticsTable
            refreshKey={props.refreshKey}
            onTemplateClick={handleTemplateClick}
          />
        </>
      )}

      {showAnalytics && selectedTemplate && (
        <>
          <Box sx={{ mt: 3, mb: 3 }}>
            <BackButton onClick={handleBackToTable} />
          </Box>

          <RCSTemplateAnalyticsTab template={selectedTemplate} bot={props.bot} />
        </>
      )}
    </Box>
  );
};

// Analytics > RCS: RCS Campaign Analytics + RCS Template Analytics as tabs,
// same structure as Analytics > WhatsApp (WhatsAppAnalyticsTab.js).
const RCSAnalyticsTab = (props) => {
  const permissionsFromStorage = JSON.parse(localStorage.getItem("permissions") || "[]");
  const hasCampaignAnalytics = permissionsFromStorage.includes("rcs_bot_create.view");
  const hasTemplateAnalytics = permissionsFromStorage.includes("template_analytics.view");

  const allTabs = [
    { label: "RCS Campaign Analytics", value: 0, show: hasCampaignAnalytics },
    { label: "Template Analytics Report", value: 1, show: hasTemplateAnalytics },
  ];
  const tabs = allTabs.filter((tab) => tab.show !== false);

  const [currentTab, setCurrentTab] = useState(tabs[0]?.value ?? 0);

  const handleTabsChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          pt: 5,
          px: 3,
          backgroundColor: "#F7F7F7",
        }}
      >
        <Box sx={{ mb: 2 }}>
          <CustomTabs
            value={currentTab}
            onChange={handleTabsChange}
            tabs={tabs}
            inactiveBgColor="#E8EAED"
            backgroundColor="#E8EAED"
          />
        </Box>

        {currentTab === 0 && hasCampaignAnalytics && <RCSCampaignAnalyticsTab {...props} />}
        {currentTab === 1 && hasTemplateAnalytics && <RCSTemplateAnalyticsReport {...props} />}
      </Box>
    </div>
  );
};

export default RCSAnalyticsTab;
